import { logger, FIELDS } from '../utils/logger.js';

export default class PageFallthrough {
  constructor(widget) {
    this.widget = widget;
    this.shadowRoot = widget.shadowRoot;
    this.config = widget.config;
    
    // Form state
    this.currentStep = 1;
    this.formData = {
      address: '',
      roofIssues: [],
      urgency: '',
      ownership: '',
      name: '',
      phone: '',
      email: ''
    };
  }

  render() {
    return `
      <div class="page" id="page-fallthrough">
        <!-- Progress indicator -->
        <div class="progress-bar">
          <div class="progress-steps">
            <span class="step" id="step-1-indicator">1</span>
            <span class="step" id="step-2-indicator">2</span>
            <span class="step" id="step-3-indicator">3</span>
            <span class="step" id="step-4-indicator">4</span>
          </div>
          <div class="progress-text">
            <span id="progress-text">Step 1 of 4</span>
          </div>
        </div>

        <!-- Step 1: Location & Situation -->
        <div class="form-step" id="step-1">
          <h2>📍 Tell us about your property</h2>
          
          <div class="form-group">
            <label for="property-address">Property Address</label>
            <input type="text" id="property-address" class="form-input" placeholder="Enter street address">
            <div class="suggestions-dropdown" id="address-suggestions"></div>
          </div>

          <div class="form-group">
            <label>⚠️ What's going on with your roof?</label>
            <div class="checkbox-group">
              <label class="checkbox-option">
                <input type="checkbox" value="storm-damage"> Storm/Wind damage
              </label>
              <label class="checkbox-option">
                <input type="checkbox" value="active-leak"> Active leak
              </label>
              <label class="checkbox-option">
                <input type="checkbox" value="planning-replacement"> Planning replacement
              </label>
              <label class="checkbox-option">
                <input type="checkbox" value="routine-inspection"> Routine inspection
              </label>
              <label class="checkbox-option">
                <input type="checkbox" value="insurance-claim"> Insurance claim help
              </label>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn btn-primary" id="step-1-next" disabled>Next</button>
          </div>
        </div>

        <!-- Step 2: Urgency & Ownership -->
        <div class="form-step" id="step-2" style="display: none;">
          <h2>⏰ When do you need help?</h2>
          
          <div class="radio-group">
            <label class="radio-option emergency">
              <input type="radio" name="urgency" value="emergency"> 🚨 Emergency - TODAY
            </label>
            <label class="radio-option urgent">
              <input type="radio" name="urgency" value="this-week"> ⚡ This week
            </label>
            <label class="radio-option normal">
              <input type="radio" name="urgency" value="this-month"> 📅 This month
            </label>
            <label class="radio-option quotes">
              <input type="radio" name="urgency" value="quotes"> 💰 Just getting quotes
            </label>
          </div>

          <div class="form-group" id="ownership-group" style="display: none;">
            <h2>🏠 Do you own this property?</h2>
            <div class="radio-group">
              <label class="radio-option">
                <input type="radio" name="ownership" value="owner"> Yes, I'm the owner
              </label>
              <label class="radio-option">
                <input type="radio" name="ownership" value="renter"> No, I'm a renter
              </label>
              <label class="radio-option">
                <input type="radio" name="ownership" value="manager"> Property manager/Other
              </label>
            </div>
          </div>

          <div class="form-actions">
            <button class="btn btn-secondary" id="step-2-back">Back</button>
            <button class="btn btn-primary" id="step-2-next" disabled>Next</button>
          </div>
        </div>

        <!-- Step 3: Contact Capture -->
        <div class="form-step" id="step-3" style="display: none;">
          <h2>📱 How can we reach you?</h2>
          
          <div class="form-group">
            <label for="contact-name">Name</label>
            <input type="text" id="contact-name" class="form-input" placeholder="First Last">
          </div>

          <div class="form-group">
            <label for="contact-phone">Phone</label>
            <input type="tel" id="contact-phone" class="form-input" placeholder="XXX-XXX-XXXX">
          </div>

          <div class="form-group">
            <label for="contact-email">Email (optional)</label>
            <input type="email" id="contact-email" class="form-input" placeholder="email@example.com">
          </div>

          <div class="form-actions">
            <button class="btn btn-secondary" id="step-3-back">Back</button>
            <button class="btn btn-primary" id="step-3-submit" disabled>Submit Request</button>
          </div>
        </div>

        <!-- Step 4: Confirmation -->
        <div class="form-step" id="step-4" style="display: none;">
          <div class="confirmation-content">
            <div class="success-icon">✅</div>
            <h2>Thank you!</h2>
            <p>We've received your roofing request and will contact you soon.</p>
            
            <div class="next-steps">
              <h3>What happens next:</h3>
              <ul>
                <li>We'll review your information</li>
                <li>A local roofing expert will contact you within 24 hours</li>
                <li>We'll schedule a convenient time for inspection</li>
              </ul>
            </div>

            <div class="form-actions">
              <button class="btn btn-secondary" id="close-widget">Close</button>
              <button class="btn btn-primary" id="try-scanner-again">Try Scanner Again</button>
            </div>
          </div>
        </div>

        <style>
          /* PageFallthrough Styles */
          #page-fallthrough {
            max-height: calc(90vh - 80px);
            overflow-y: auto;
            padding: 20px;
          }

          /* Progress Bar */
          .progress-bar {
            background: white;
            border-radius: 12px;
            padding: 20px;
            margin-bottom: 24px;
            border: 1px solid #e5e7eb;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }

          .progress-steps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            position: relative;
          }

          .progress-steps::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            height: 2px;
            background: #e5e7eb;
            transform: translateY(-50%);
            z-index: 0;
          }

          .step {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            background: white;
            border: 2px solid #e5e7eb;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 14px;
            color: #9ca3af;
            position: relative;
            z-index: 1;
            transition: all 0.3s ease;
          }

          .step.active {
            background: #6366f1;
            border-color: #6366f1;
            color: white;
            box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
          }

          .step.completed {
            background: #22c55e;
            border-color: #22c55e;
            color: white;
          }

          .progress-text {
            text-align: center;
            font-size: 14px;
            color: #000000;
            font-weight: 500;
          }

          /* Form Steps */
          .form-step {
            background: white;
            border-radius: 12px;
            padding: 32px;
            border: 1px solid #e5e7eb;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }

          .form-step h2 {
            font-size: 24px;
            font-weight: 700;
            color: #000000;
            margin: 0 0 24px 0;
          }

          .form-step h3 {
            font-size: 18px;
            font-weight: 600;
            color: #000000;
            margin: 0 0 16px 0;
          }

          /* Form Groups */
          .form-group {
            margin-bottom: 24px;
          }

          .form-group label {
            display: block;
            font-size: 14px;
            font-weight: 500;
            color: #000000;
            margin-bottom: 8px;
          }

          .form-input {
            width: 100%;
            padding: 12px 16px;
            border: 2px solid #e5e7eb;
            border-radius: 8px;
            font-size: 14px;
            color: #000000;
            background: white;
            transition: all 0.3s ease;
            box-sizing: border-box;
          }

          .form-input:focus {
            outline: none;
            border-color: #6366f1;
            box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
          }

          .form-input::placeholder {
            color: #9ca3af;
          }

          /* Checkbox Group */
          .checkbox-group {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .checkbox-option {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            background: #f9fafb;
            border: 2px solid #e5e7eb;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 14px;
            color: #000000;
            font-weight: 500;
          }

          .checkbox-option:hover {
            border-color: #cbd5e1;
            background: #f3f4f6;
          }

          .checkbox-option input[type="checkbox"] {
            margin-right: 12px;
            width: 18px;
            height: 18px;
            cursor: pointer;
            accent-color: #6366f1;
          }

          .checkbox-option:has(input:checked) {
            border-color: #6366f1;
            background: rgba(99, 102, 241, 0.05);
          }

          /* Radio Group */
          .radio-group {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 24px;
          }

          .radio-option {
            display: flex;
            align-items: center;
            padding: 16px 20px;
            background: white;
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 16px;
            color: #000000;
            font-weight: 500;
          }

          .radio-option:hover {
            border-color: #cbd5e1;
            transform: translateX(4px);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .radio-option input[type="radio"] {
            margin-right: 12px;
            width: 20px;
            height: 20px;
            cursor: pointer;
            accent-color: #6366f1;
          }

          .radio-option:has(input:checked) {
            border-color: #6366f1;
            background: rgba(99, 102, 241, 0.05);
            box-shadow: 0 0 0 1px #6366f1;
          }

          /* Urgency-specific styling */
          .radio-option.emergency:has(input:checked) {
            border-color: #ef4444;
            background: rgba(239, 68, 68, 0.05);
            box-shadow: 0 0 0 1px #ef4444;
          }

          .radio-option.urgent:has(input:checked) {
            border-color: #f59e0b;
            background: rgba(245, 158, 11, 0.05);
            box-shadow: 0 0 0 1px #f59e0b;
          }

          /* Buttons */
          .form-actions {
            display: flex;
            gap: 12px;
            justify-content: flex-end;
            margin-top: 32px;
          }

          .btn {
            padding: 12px 24px;
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .btn-primary {
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            color: white;
            box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
            position: relative;
            overflow: hidden;
          }

          .btn-primary::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
            transition: left 0.3s ease;
            z-index: 0;
          }

          .btn-primary span {
            position: relative;
            z-index: 1;
          }

          .btn-primary:hover:not(:disabled)::before {
            left: 0;
          }

          .btn-primary:hover:not(:disabled) {
            box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
            transform: translateY(-1px);
          }

          .btn-primary:disabled {
            background: #e5e7eb;
            cursor: not-allowed;
            box-shadow: none;
            color: #9ca3af;
          }

          .btn-primary:disabled::before {
            display: none;
          }

          .btn-secondary {
            background: white;
            border: 2px solid #cbd5e1;
            color: #000000;
          }

          .btn-secondary:hover {
            background: #f1f5f9;
            border-color: #94a3b8;
            transform: translateY(-1px);
          }

          /* Confirmation Content */
          .confirmation-content {
            text-align: center;
            padding: 20px;
          }

          .success-icon {
            font-size: 64px;
            margin-bottom: 24px;
            animation: successPop 0.5s ease-out;
          }

          @keyframes successPop {
            0% {
              transform: scale(0);
              opacity: 0;
            }
            50% {
              transform: scale(1.2);
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

          .confirmation-content h2 {
            color: #000000;
            margin-bottom: 16px;
          }

          .confirmation-content p {
            font-size: 16px;
            color: #000000;
            line-height: 1.6;
            margin-bottom: 32px;
          }

          .next-steps {
            background: #f9fafb;
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 32px;
            text-align: left;
            border: 1px solid #e5e7eb;
          }

          .next-steps h3 {
            font-size: 16px;
            font-weight: 600;
            color: #000000;
            margin: 0 0 16px 0;
          }

          .next-steps ul {
            margin: 0;
            padding-left: 20px;
          }

          .next-steps li {
            font-size: 14px;
            color: #000000;
            line-height: 1.8;
            margin-bottom: 8px;
          }

          .confirmation-content .form-actions {
            justify-content: center;
          }

          /* Suggestions Dropdown */
          .suggestions-dropdown {
            position: absolute;
            width: 100%;
            max-height: 200px;
            overflow-y: auto;
            background: white;
            border: 2px solid #e5e7eb;
            border-top: none;
            border-radius: 0 0 8px 8px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            z-index: 10;
            display: none;
          }

          /* Ownership Group Animation */
          #ownership-group {
            animation: slideDown 0.3s ease-out;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Responsive */
          @media (max-width: 768px) {
            #page-fallthrough {
              padding: 16px;
            }

            .form-step {
              padding: 24px 20px;
            }

            .form-step h2 {
              font-size: 20px;
            }

            .form-actions {
              flex-direction: column-reverse;
            }

            .btn {
              width: 100%;
              justify-content: center;
            }

            .progress-steps {
              padding: 0 10px;
            }

            .step {
              width: 32px;
              height: 32px;
              font-size: 12px;
            }
          }
        </style>
      </div>
    `;
  }

  onMount(data = {}) {
    this.setupEventListeners();
    this.updateProgressIndicator();
    
    // Pre-populate address from widget session data
    const selectedAddress = this.widget.getSessionData('selected_address');
    if (selectedAddress && selectedAddress.address) {
      const addressInput = this.shadowRoot.querySelector('#property-address');
      if (addressInput) {
        addressInput.value = selectedAddress.address;
        this.formData.address = selectedAddress.address;

        // Trigger validation to enable next button if address is valid
        this.validateStep1();
      }
    }
    
    // Pre-populate address if available from error data coordinates (fallback)
    if (data.coordinates) {
      // Could reverse geocode coordinates to address
    }
  }

  onUnmount() {
  }

  setupEventListeners() {
    // Step 1 listeners
    this.setupStep1Listeners();
    
    // Step 2 listeners  
    this.setupStep2Listeners();
    
    // Step 3 listeners
    this.setupStep3Listeners();
    
    // Step 4 listeners
    this.setupStep4Listeners();
  }

  setupStep1Listeners() {
    const addressInput = this.shadowRoot.querySelector('#property-address');
    const checkboxes = this.shadowRoot.querySelectorAll('input[type="checkbox"]');
    const nextButton = this.shadowRoot.querySelector('#step-1-next');

    // Address input
    addressInput.addEventListener('input', (e) => {
      this.formData.address = e.target.value;
      
      // Update session data with the modified address
      const currentSessionAddress = this.widget.getSessionData('selected_address') || {};
      this.widget.setSessionData('selected_address', {
        ...currentSessionAddress,
        address: e.target.value,
        lastModified: new Date().toISOString()
      });
      
      this.validateStep1();
    });

    // Roof issues checkboxes
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.formData.roofIssues.push(e.target.value);
        } else {
          this.formData.roofIssues = this.formData.roofIssues.filter(issue => issue !== e.target.value);
        }
        this.validateStep1();
      });
    });

    // Next button
    nextButton.addEventListener('click', () => {
      this.nextStep();
    });
  }

  setupStep2Listeners() {
    const urgencyRadios = this.shadowRoot.querySelectorAll('input[name="urgency"]');
    const ownershipRadios = this.shadowRoot.querySelectorAll('input[name="ownership"]');
    const backButton = this.shadowRoot.querySelector('#step-2-back');
    const nextButton = this.shadowRoot.querySelector('#step-2-next');

    // Urgency selection - auto-advance after selection
    urgencyRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.formData.urgency = e.target.value;
        // Show ownership question after urgency is selected
        setTimeout(() => {
          this.showOwnershipQuestion();
        }, 500);
      });
    });

    // Ownership selection
    ownershipRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.formData.ownership = e.target.value;
        this.validateStep2();
      });
    });

    // Navigation buttons
    backButton.addEventListener('click', () => this.previousStep());
    nextButton.addEventListener('click', () => this.nextStep());
  }

  setupStep3Listeners() {
    const nameInput = this.shadowRoot.querySelector('#contact-name');
    const phoneInput = this.shadowRoot.querySelector('#contact-phone');
    const emailInput = this.shadowRoot.querySelector('#contact-email');
    const backButton = this.shadowRoot.querySelector('#step-3-back');
    const submitButton = this.shadowRoot.querySelector('#step-3-submit');

    // Contact inputs
    nameInput.addEventListener('input', (e) => {
      this.formData.name = e.target.value;
      this.validateStep3();
    });

    phoneInput.addEventListener('input', (e) => {
      this.formData.phone = e.target.value;
      this.validateStep3();
    });

    emailInput.addEventListener('input', (e) => {
      this.formData.email = e.target.value;
    });

    // Navigation buttons
    backButton.addEventListener('click', () => this.previousStep());
    submitButton.addEventListener('click', () => this.submitForm());
  }

  setupStep4Listeners() {
    const closeButton = this.shadowRoot.querySelector('#close-widget');
    const tryAgainButton = this.shadowRoot.querySelector('#try-scanner-again');

    closeButton.addEventListener('click', () => {
      this.widget.close();
    });

    tryAgainButton.addEventListener('click', () => {
      this.widget.showPage(1);
    });
  }

  validateStep1() {
    const hasAddress = this.formData.address.trim().length > 0;
    const hasIssues = this.formData.roofIssues.length > 0;
    const nextButton = this.shadowRoot.querySelector('#step-1-next');
    
    nextButton.disabled = !(hasAddress && hasIssues);
  }

  validateStep2() {
    const hasUrgency = this.formData.urgency !== '';
    const hasOwnership = this.formData.ownership !== '';
    const nextButton = this.shadowRoot.querySelector('#step-2-next');
    
    nextButton.disabled = !(hasUrgency && hasOwnership);
  }

  validateStep3() {
    const hasName = this.formData.name.trim().length > 0;
    const hasPhone = this.formData.phone.trim().length > 0;
    const submitButton = this.shadowRoot.querySelector('#step-3-submit');
    
    submitButton.disabled = !(hasName && hasPhone);
  }

  showOwnershipQuestion() {
    const ownershipGroup = this.shadowRoot.querySelector('#ownership-group');
    ownershipGroup.style.display = 'block';
    ownershipGroup.scrollIntoView({ behavior: 'smooth' });
  }

  nextStep() {
    if (this.currentStep < 4) {
      this.showStep(this.currentStep + 1);
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.showStep(this.currentStep - 1);
    }
  }

  showStep(stepNumber) {
    // Hide current step
    const currentStepElement = this.shadowRoot.querySelector(`#step-${this.currentStep}`);
    if (currentStepElement) {
      currentStepElement.style.display = 'none';
    }

    // Show new step
    const newStepElement = this.shadowRoot.querySelector(`#step-${stepNumber}`);
    if (newStepElement) {
      newStepElement.style.display = 'block';
    }

    // Update current step
    this.currentStep = stepNumber;
    this.updateProgressIndicator();
  }

  updateProgressIndicator() {
    // Update step indicators
    for (let i = 1; i <= 4; i++) {
      const indicator = this.shadowRoot.querySelector(`#step-${i}-indicator`);
      if (indicator) {
        if (i < this.currentStep) {
          indicator.classList.add('completed');
          indicator.classList.remove('active');
        } else if (i === this.currentStep) {
          indicator.classList.add('active');
          indicator.classList.remove('completed');
        } else {
          indicator.classList.remove('active', 'completed');
        }
      }
    }

    // Update progress text
    const progressText = this.shadowRoot.querySelector('#progress-text');
    if (progressText) {
      progressText.textContent = `Step ${this.currentStep} of 4`;
    }
  }

  async submitForm() {
    try {
      // TODO: Submit form data to server
      // const response = await fetch('/api/roofing-leads', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(this.formData)
      // });
      
      // Show success step
      this.showStep(4);

    } catch (error) {
      logger.error({
        [FIELDS.ERROR]: error,
        [FIELDS.OPERATION]: 'submitForm',
        [FIELDS.REASON]: 'form_submission_failed'
      }, 'PageFallthrough form submission error');
      // Handle error - could show error message
    }
  }
}